import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  Grid,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import { useMutation } from "@apollo/client";
import { JSButton } from "components/common/JButton";
import { EVALUATE_BEHAVIOR } from "graphql/mutations/behavior";
import { D2DAutocomplete } from "components/common";
import { GET_BEHAVIORS_QUERY } from "graphql/queries/behaviors";
import { useRequestQuery } from "helpers/useRequest";
import { notifier } from "utils/helpers";
import { useAuth } from "providers/auth";
import moment from "moment";
import { JInput } from "components/common/JForm/JInput";

const initialStateItem = { name: "", rate: "", description: "" };

export const EvaluateBehavior = ({ open, onClose, refetch }) => {
  const [item, setItem] = useState(initialStateItem);
  const { user } = useAuth();
  const { results, loading: fetching } = useRequestQuery({
    query: GET_BEHAVIORS_QUERY,
    variables: { searchKey: item.name },
    dataType: "behaviorsList",
  });
  const [saveScore, { loading: saving, data: savedData, reset }] =
    useMutation(EVALUATE_BEHAVIOR);

  useEffect(() => {
    if (savedData?.evaluateBehavior) {
      onClose();
      refetch();
      setItem(initialStateItem);
      setTimeout(() => {
        reset();
      }, 1000);
    }
  }, [savedData, onClose, reset, refetch]);

  const handleChangeInput = ({ target: { name, value } }) => {
    setItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleACChange = (key) => (_, value) => {
    setItem((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    if (!item.name || !item.rate) {
      notifier("Please fill in all the fields");
      return;
    }
    saveScore({
      variables: {
        ...item,
        actionDate: moment().format("YYYY-MM-DD"),
        householdId: user.householdSet?.[0]?.id,
      },
    });
  };
  const behaviorsList = useMemo(
    () => results?.pageData?.map((rs) => rs.name) || [],
    [results?.pageData]
  );
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="add-dialog">
        Select a behavior an evaluate it
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Type a behavior name, new or existing, and the score yo want to give
          it
        </DialogContentText>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <D2DAutocomplete
              id="name"
              name="name"
              label="Select behavior name"
              options={behaviorsList}
              onInputChange={handleACChange("name")}
              value={item.name}
              freeSolo
              isLoading={fetching}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                How did you do about the behavior
              </FormLabel>
              <RadioGroup
                row
                aria-label="rate"
                name="rate"
                onChange={handleChangeInput}
              >
                <FormControlLabel
                  value="good"
                  control={<Radio color="primary" />}
                  label="I did good"
                />
                <FormControlLabel
                  value="bad"
                  control={<Radio color="secondary" />}
                  label="I failed"
                />
                <FormControlLabel
                  value="so-so"
                  control={<Radio color="default" />}
                  label="I was so-so"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <JInput
              name="description"
              placeholder="What did do, or why do u think you did"
              value={item.description}
              onChange={handleChangeInput}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <JSButton loading={saving} onClick={handleSave} />
      </DialogActions>
    </Dialog>
  );
};
